<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter">
            <el-form-item label="分销状态：">
                <el-select v-model="searchForm.isSold" clearable>
                    <el-option label="未分销" value="0"></el-option>
                    <el-option label="已分销" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡状态：">
                <el-select v-model="searchForm.cardState" clearable>
                    <el-option v-for="item in cardStateOption" :value="item.code" :key="item.id + item.description"
                        :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="实名状态：">
                <el-select v-model="searchForm.isAuth" clearable>
                    <el-option label="未实名" value="0"></el-option>
                    <el-option label="已实名" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="移动冻结：">
                <el-select v-model="searchForm.isDong" clearable>
                    <el-option label="已冻结" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商名称：">
                <el-select v-model="searchForm.supplierCode" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                        :label="item.name + '(' + item.alias + ')'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐组名称：">
                <el-select v-model="searchForm.basePkgGroup" clearable filterable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属业务员：">
                <el-select v-model="searchForm.yewuId" filterable>
                    <el-option v-for="item in yewuData" :value="item.id" :key="item.id"
                        :label="item.name + '（' + item.sysUserAccountName + '）'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分销商：">
                <el-input v-model.trim="searchForm.agentName" @keyup.enter.native="getAdminCardListHandler"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAdminCardListHandler"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" @keyup.enter.native="getAdminCardListHandler"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="虚拟号：">
                <el-input v-model.trim="searchForm.virtualNo" @keyup.enter.native="getAdminCardListHandler"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input v-model.trim="searchForm.userPhone" @keyup.enter.native="getAdminCardListHandler"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="卡板号段：" class="ICCIDRange">
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidStart" placeholder="支持虚拟号段" clearable></el-input>
                </el-col>
                <el-col :span="2" class="separate">-</el-col>
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidEnd" placeholder="搜索-分销-回收功能" clearable></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="卡备注：">
                <el-input v-model.trim="searchForm.remark" @keyup.enter.native="getAdminCardListHandler"
                    clearable></el-input>
            </el-form-item>

            <el-form-item label="卡限额：">
                <el-input v-model.trim="searchForm.dayLimit" @keyup.enter.native="getAdminCardListHandler"
                    placeholder="限额大于多少GB" clearable></el-input>
            </el-form-item>
            <br />


            <!-- <el-form-item label="剩于流量(G)：" class="iccid_number_input">
                <el-row style="display:flex;width:400px;">
                    <el-col style="flex:3">
                        <el-select  clearable v-model="searchForm.op2" placeholder="请选择">
                            <el-option
                            v-for="item in ops"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="1" class="separate"></el-col>
                    <el-col style="flex:7">
                        <el-input-number :min="0" v-model="searchForm.plusFlowRate" clearable></el-input-number>
                    </el-col>
                </el-row>                
                
            </el-form-item> -->
            <br />
            <el-form-item label="批量搜索：" class="iccid_textarea_range">
                <el-input type="textarea" :rows="2" placeholder="请输入1个或多个ICCID号,多个请用逗号、空格、或者换行分隔"
                    v-model="searchForm.iccidStrs">
                </el-input>
            </el-form-item>
            <br />
            <el-form-item label="虚拟号搜索：" class="iccid_textarea_range">
                <el-input type="textarea" :rows="2" placeholder="请输入1个或多个虚拟卡号,多个请用逗号、空格、或者换行分隔"
                    v-model="searchForm.vriNoStrs">
                </el-input>
            </el-form-item>
            <!-- <el-form-item label="排序规则："> 
                <el-select v-model="searchForm.orderBy" clearable>
                    <el-option label="过期时间" value="expire_time"></el-option>
                    <el-option label="使用流量" value="use_flow"></el-option>
                </el-select>
            </el-form-item> -->

            <el-form-item class="btnArea">
                <el-button type="primary" @click="getAdminCardListHandler" icon="el-icon-search">搜索查询</el-button>
                <el-button type="primary" @click="showSimHandle" icon="el-icon-s-ticket">SIM卡分销</el-button>
                <el-button type="danger" @click="simRecycleHandle" icon="el-icon-s-ticket">SIM卡回收</el-button>
                <el-button type="danger" @click="deleteSimNew" icon="el-icon-delete">批量删除</el-button>
                <el-button type="success" @click="getAdminCardListHandlerAuth">批量更新</el-button>
                <el-button type="warning" @click="simHandleVisibale2 = true" icon="el-icon-edit">批量变更卡状态</el-button>
                <el-button type="danger" @click="noInevntPowerBatch">未充值卡禁止充值</el-button>
                <el-button type="primary" @click="simHandleVisibale1 = true" icon="el-icon-edit">批量转通道</el-button>
                <el-button type="success" @click="simHandleVisibales = true" icon="el-icon-s-ticket">批量转套餐系列</el-button>
                <el-button type="success" icon="el-icon-edit" class="onlyBtn" plain
                    @click="showBatchChgStateHandler()">批量备注</el-button>
                <el-button type="success" icon="el-icon-edit" class="onlyBtn" plain
                    @click="cmccDongState()">移动卡冻结更新</el-button>
                <el-button type="success" @click="updateUrlByExcel" icon="el-icon-s-ticket">日限额</el-button>

                <el-button type="success" @click="changeGroupFlg=true" icon="el-icon-s-ticket">达量转套餐组</el-button>

                <el-button type="success" @click="exportSimInfoHandle" plain icon="el-icon-download">导出Excel</el-button>

            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            :header-cell-style="{ background: '#f5f5f5' }">
            <el-table-column label="ICCID号" width="180px" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="intoNo" label="接入号" width="130px"></el-table-column>
            <el-table-column align="center" prop="virtualNo" label="虚拟号" width="130px"></el-table-column>
            <el-table-column align="center" prop="userAmount" label="卡余额" width="90px"></el-table-column>
            <el-table-column align="center" label="分润设置" width="100px">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.soldName == '已设置'" :content="scope.row.soldName">
                        <p style="color:green"> {{ scope.row.soldName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else :content="scope.row.soldName">
                        <p style="color:red"> {{ scope.row.soldName }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>

            <el-table-column align="center" prop="supplierName" label="供应商名称" width="120"></el-table-column>
            <el-table-column align="center" label="卡状态" width="100px">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.cardState == 2" :content="scope.row.cardStateName">
                        <p style="color:green"> {{ scope.row.cardStateName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else-if="scope.row.cardState == 1 || scope.row.cardState == 0"
                        :content="scope.row.cardStateName">
                        <p style="color:brown"> {{ scope.row.cardStateName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else :content="scope.row.cardStateName">
                        <p style="color:crimson"> {{ scope.row.cardStateName }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>

            <el-table-column align="center" label="实名状态">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.authName == '已实名'" :content="scope.row.authName">
                        <p style="color:green"> {{ scope.row.authName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else :content="scope.row.authName">
                        <p style="color:crimson"> {{ scope.row.authName }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="createTime" label="导入时间"  width="140px"></el-table-column> -->
            <el-table-column align="center" prop="batchNo" label="导入批次" width="80px"></el-table-column>
            <el-table-column align="center" prop="basePkgGroupName" label="套餐组" width="130px"></el-table-column>
            <el-table-column align="center" label="总流量(G)" width="80px">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.flowRate) }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="已使用流量(G)" width="110px">
                <template slot-scope="scope">
                    <p style="color:#99BBFF"> {{ fluxMtoG(scope.row.usedFlowRate) }}</p>
                </template>
            </el-table-column>
            <el-table-column align="center" label="剩余流量(G)" width="100px">
                <template slot-scope="scope">
                    {{ decrease(fluxMtoG(scope.row.flowRate), fluxMtoG(scope.row.usedFlowRate)) }}
                </template>
            </el-table-column>

            <el-table-column align="center" label="日限额(G)" width="100px">
                <template slot-scope="scope">
                    {{ scope.row.dayLimit }}
                </template>
            </el-table-column>

            <el-table-column align="center" label="达量迁移(G)" width="100px">
                <template slot-scope="scope">
                    {{ scope.row.groupData }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="groupName" label="迁移套餐组" width="120"></el-table-column>

            <el-table-column align="center" label="分销商" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="color: #f54848;">{{ formatAgentNamePrefix(scope.row.agentPathNames) }}</span>{{
                        scope.row.agentPathNames }}
                </template>
            </el-table-column>


            <el-table-column align="center" label="数据状态" width="100px">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.dataState == '开启'" :content="scope.row.dataState">
                        <p style="color:green"> {{ scope.row.dataState }}</p>
                    </el-tooltip>
                    <el-tooltip v-else :content="scope.row.dataState">
                        <p style="color:crimson"> {{ scope.row.dataState }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="isSoldName" label="分销状态" width="100"></el-table-column>
            <el-table-column align="center" label="移动冻结" width="100px">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.dongRemark">
                        <p style="color:crimson"> {{ scope.row.dongRemark }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column align="center" label="卡备注" width="100px">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.remark">
                        <p style="color:crimson"> {{ scope.row.remark }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>


            <el-table-column label="操作" width="210" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="updateStateHandler(scope.row.iccid, true)">刷新</el-button>
                    <el-button type="success" size="small" @click="resetSimHandler(scope.row.iccid)">复机</el-button>
                    <el-button type="danger" size="small" @click="stopSimHandler(scope.row.iccid)">停机</el-button>
                </template>
            </el-table-column>
        </el-table>
        <p v-if="searchForm.basePkgGroup != '' && searchForm.basePkgGroup != null" style="color:red;text-align:center;">
            卡片总数：{{ remark.total }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 在用卡数：{{ remark.activing }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 累计激活：{{ remark.allActive }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 激活率：{{ remark.activeParent }}% &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            使用流量：{{ remark.totalData }} /G
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            产生利润：{{ remark.price }} /元

        </p>

        <p v-else style="color:red;text-align:center;">总真实用量：{{ allSimTotalData }}/GB ，可以根据查询套餐组，来显示具体的激活率和利润信息。</p>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" title="卡片分销" :visible.sync="simHandleVisibale" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" :rules="simHandleRules" label-width="120px">
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="searchForm.agentId" filterable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id"
                            :label="`${item.name + '  (账号：' + item.sysUserAccountName + ' )'}`"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="simDistributHandler">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="批量转通道" :visible.sync="simHandleVisibale1" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" label-width="120px">
                <el-form-item label="运营商：" prop="toSupplierCode">
                    <el-select v-model="searchForm.toSupplierCode" filterable>
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="batchUpdateSupplier">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="批量转套餐组" :visible.sync="simHandleVisibales" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" label-width="120px">
                <el-form-item label="新套餐组：" prop="basePkgGroupNew">
                    <el-select v-model="searchForm.basePkgGroupNew" filterable>
                        <el-option v-for="item in pkgGroup" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="batUpdateGroup">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="批量变更卡状态" :visible.sync="simHandleVisibale2" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" :rules="simHandleRules" label-width="120px">
                <el-form-item label="卡状态：" prop="newCardState">
                    <el-select v-model="searchForm.newCardState" filterable>
                        <el-option v-for="item in cardStateOption" :value="item.code" :key="item.code"
                            :label="item.description"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureUpdateSimState">确 定</el-button>
            </div>
        </el-dialog>



        <el-dialog :append-to-body="true" title="批量变更备注" :visible.sync="batchOptVisible" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm" :rules="changeStateRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/import/update/remark')" :headers="setHeader()"
                        :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success='handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="batchOptForm.remark"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler">确 定</el-button>
            </div>
        </el-dialog>



        <el-dialog :append-to-body="true" title="当月限额迁移" :visible.sync="changeGroupFlg" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" label-width="120px">
                <el-form-item label="新套餐组：" prop="groupId">
                    <el-select v-model="searchForm.groupId" filterable>
                        <el-option v-for="item in pkgGroup" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="当月限额/GB：" prop="groupData">
                    <el-input v-model="searchForm.groupData"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="batUpdateGroupChange">确 定</el-button>
            </div>
        </el-dialog>









        <el-dialog :append-to-body="true" title="批量修改活码" :visible.sync="updateUrlFlg" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" label-width="120px">
                <el-form-item label="充值链接：">
                    <el-input v-model.trim="searchForm.inventUrl" clearable></el-input>
                </el-form-item>

                <!-- <el-form-item label="客服链接：">
                    <el-input v-model.trim="searchForm.kefuUrl" clearable></el-input>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureUpdateUrl">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog :append-to-body="true" title="日限额" :visible.sync="updateUrlByExcelFlg" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/DayLimito')" :headers="setHeader()" :auto-upload="false"
                        :data="searchForm" :on-change="handleChange" :on-success='handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=dayLimit')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureExcelUpdateUrl">确 定</el-button>
            </div>
        </el-dialog>



        <!-- 
        <el-dialog :append-to-body="true" title="EXCEL修改活码" :visible.sync="updateUrlByExcelFlg" width="600px"
            @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/update/change/excel')" :headers="setHeader()"
                        :auto-upload="false" :data="searchForm" :on-change="handleChange" :on-success='handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=updateUrl')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureExcelUpdateUrl">确 定</el-button>
            </div>
        </el-dialog>
 -->

    </div>
</template>

<script>
import { getAdminCardList, simDistribut, simRecovery, getCardStateDict, exportSimInfo, simRecovery1, simRecovery2, simRecovery3, simRecovery4, getAdminCardListAuth } from '@/api/sim.js'
import { updateState, stopSim, resetSim } from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data() {
        return {
            changeGroupFlg: false,

            batchOptForm: {
                remark: ''
            },
            remark: {
                total: 0,
                activing: 0,
                allActive: 0,
                activeParent: 0,
                price: 0,
                totalData: 0
            },
            searchForm: {
                groupData: '',
                groupId: '',

                vriNoStrs: '',
                remark: '',
                isSold: '',
                cardState: '',
                supplierCode: '',
                toSupplierCode: '',
                basePkgGroup: '',
                basePkgGroupNew: '',
                agentName: '',
                iccid: '',
                intoNo: '',
                iccidStart: '',
                iccidEnd: '',
                orderBy: '',
                usedFlowRate: null,
                plusFlowRate: null,
                op: '',
                op2: '',
                virtualNo: '',
                isAuth: '',
                intoNos: '',
                inventUrl: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            simHandleVisibale1: false,
            simHandleVisibale: false,
            simHandleVisibale2: false,
            simHandleForm: {
                agentId: ''
            },
            yewuData: [],
            pkgGroup: [],
            branchSupplierOption: [],
            agentListOption: [],
            cardStateOption: [],
            simHandleVisibales: false,
            virtualStateArray: [],
            simHandleRules: {
                agentId: [{ required: true, message: '请选择代理商', trigger: 'change' }]
            },
            ops: [
                { label: '等于', value: "=" },
                { label: '大于', value: ">" }
            ],
            batchOptVisible: false,
            changeStateRules: {},
            updateUrlFlg: false,
            updateUrlByExcelFlg: false,
            allSimTotalData: '',

        }
    },
    methods: {
        updateUrlByExcel() {
            this.updateUrlByExcelFlg = true;
        },
        sureExcelUpdateUrl() {
            this.$refs.searchForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });

        },

        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }

        },
        handleSuccess(res) {
            if (res.code == 200) {
                this.getAdminCardListHandler();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.upload.clearFiles();
        },


        updateUrlByExcel() {
            this.updateUrlByExcelFlg = true;
        },
        sureExcelUpdateUrl() {
            this.$refs.searchForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });

        },


        updateUrlBySelect() {
            this.updateUrlFlg = true;
        },
        sureUpdateUrl() {
            common.sysRequest("sim/update/change/url", this.searchForm, 'post').then(res => {
                if (res.data.code == 200) {
                    this.searchForm.inventUrl = '';
                    this.searchForm.kefuUrl = '';
                    this.$message.success(res.data.message);
                    this.updateUrlFlg = false;
                    this.getAdminCardListHandler();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },



        getAdminCardListHandlerAuth($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            if (data.usedFlowRate) {
                data.usedFlowRate = data.usedFlowRate * 1024;
            }
            if (data.plusFlowRate) {
                data.plusFlowRate = data.plusFlowRate * 1024;
            }
            common.sysRequest("sim/update/batch/state", data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.getAdminCardListHandler();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },


        updateStateHandler(iccid, showSuccessMsg) {
            var data = { iccid };
            updateState(data).then(res => {
                if (res.data.code == 200) {
                    if (showSuccessMsg) {
                        this.$message.success(res.data.message);
                    }
                    this.getAdminCardListHandler();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        stopSimHandler(iccid) {
            this.$confirm("您确定要进行停机操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: iccid
                }
                stopSim(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("停机完成！");
                        this.getAdminCardListHandler();
                    } else {
                        if (res.data) {
                            this.$message.error(res.data.message);
                        }
                    }
                })
            })
        },
        resetSimHandler(iccid) {
            this.$confirm("您确定要进行复机操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: iccid
                }
                resetSim(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("复机完成！")
                        this.getAdminCardListHandler();
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            })
        },




        sureBatchChgStateHandler() {
            this.$refs.batchOptForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },


        showBatchChgStateHandler() {
            this.batchOptVisible = true;
        },

        cancel() {
            this.changeGroupFlg = false;
            this.updateUrlFlg = false;
            this.updateUrlByExcelFlg = false;
            this.batchOptVisible = false;
            this.simHandleVisibale = false;
            this.simHandleVisibale2 = false;
            this.simHandleVisibale1 = false;
            this.simHandleVisibales = false;
            this.$refs.simHandleForm.resetFields();
            this.searchForm.groupData = '';
            this.searchForm.groupId = '';
        },
        getAdminCardListHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            if (data.usedFlowRate) {
                data.usedFlowRate = data.usedFlowRate * 1024;
            }

            if (data.plusFlowRate) {
                data.plusFlowRate = data.plusFlowRate * 1024;
            }
            getAdminCardList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
                if (res.data.data.remarkMap) {
                    if (this.searchForm.basePkgGroup != '' && this.searchForm.basePkgGroup != null) {
                        this.remark = res.data.data.remarkMap;
                    }
                    this.allSimTotalData = res.data.data.remarkMap.totalData;
                }
            })
        },
        batUpdateGroupChange($event) {
            this.$confirm("本次操作预计" + this.tbpg.total + "/条数据，建议先搜索核实后再操作。确定要操作嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.resetCurrentPage(this, $event, 'tbpg');
                var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                common.sysRequest("sim/batUpdateGroupChange", data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.cancel();
                        this.getAdminCardListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },


        batUpdateGroup($event) {
            this.$confirm("本次操作预计" + this.tbpg.total + "/条数据，建议先搜索核实后再操作。确定要操作嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.resetCurrentPage(this, $event, 'tbpg');
                var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                common.sysRequest("sim/batUpdateGroup", data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.simHandleVisibales = false;
                        this.getAdminCardListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },

        cmccDongState($event) {
            this.$confirm("本次操作预计" + this.tbpg.total + "/条数据，建议先搜索核实后再操作 仅支持移动卡。确定要操作嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.resetCurrentPage(this, $event, 'tbpg');
                var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                common.sysRequest("sim/updateCmccDong", data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getAdminCardListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },

        batchUpdateSupplier($event) {
            this.$confirm("本次操作预计" + this.tbpg.total + "/条数据，建议先搜索核实后再操作。确定要操作嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.resetCurrentPage(this, $event, 'tbpg');
                var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                common.sysRequest("sim/batchUpdateSupplier", data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.simHandleVisibale1 = false;
                        this.getAdminCardListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },


        noInevntPowerBatch($event) {
            this.$confirm("本次操作预计" + this.tbpg.total + "/条数据（确认好卡将会变成运营商维护状态，用户不能不能充值）。确定要操作嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.resetCurrentPage(this, $event, 'tbpg');
                var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                common.sysRequest("sim/noInevntPowerBatch", data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.simHandleVisibale2 = false;
                        this.getAdminCardListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },

        sureUpdateSimState($event) {
            this.$confirm("本次操作预计" + this.tbpg.total + "/条数据，如果改为停机/已激活状态，会执行运营商接口操作。确定要操作嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.resetCurrentPage(this, $event, 'tbpg');
                var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                common.sysRequest("sim/updateSimState", data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.simHandleVisibale2 = false;
                        this.getAdminCardListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },


        deleteSimNew($event) {
            this.$confirm("本次操作预计" + this.tbpg.total + "/条数据，数据一旦删除 无法恢复！建议先搜索核实后再操作。确定要操作嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.resetCurrentPage(this, $event, 'tbpg');
                var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                common.sysRequest("sim/deleteBach", data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.simHandleVisibale = false;
                        this.getAdminCardListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },

        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        showSimHandle() {
            this.simHandleVisibale = true;
            common.getAgentListOptionCom1(this, 'agentListOption');
        },

        showSimHandle1() {
            this.simHandleVisibale1 = true;
        },
        simRecycleHandle($event) {
            this.$confirm("本次操作预计" + this.tbpg.total + "/条数据，建议先搜索核实后再操作。确定要操作嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.resetCurrentPage(this, $event, 'tbpg');
                var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                common.sysRequest("sim/reloadBatch", data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.simHandleVisibale = false;
                        this.getAdminCardListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },
        simDistributHandler($event) {
            this.$confirm("本次操作预计" + this.tbpg.total + "/条数据，建议先搜索核实后再操作。确定要操作嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.resetCurrentPage(this, $event, 'tbpg');
                var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                common.sysRequest("sim/soldbacth", data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.simHandleVisibale = false;
                        this.getAdminCardListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },

        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getAdminCardListHandler();
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val;
            this.getAdminCardListHandler();
        },
        exportSimInfoHandle() {//导出excel文件
            this.$confirm("您确定要导出SIM卡列表吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {

                let data = this.searchForm;
                if (data.usedFlowRate) {
                    data.usedFlowRate = data.usedFlowRate * 1024;
                }
                if (data.plusFlowRate) {
                    data.plusFlowRate = data.plusFlowRate * 1024;
                }

                exportSimInfo(this.searchForm).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(err => console.error(err));
            })
        },

        //检查是不是自收款代理商
        formatAgentNamePrefix(name) {

            let names = ['盛世蓝泰科技', '云游互动云游卡', '蔡伟成', '野马通信', '魅友通', '四海龙腾'];
            let pre = '';
            if (name) {
                names.forEach(function (currentValue) {
                    if (name.indexOf(currentValue) == 0) {
                        pre = '【自收款】'
                    }
                });
                return pre;
            }
            return '';
        }

    },
    created() {
        common.getAgentListOptionComs(this, 'yewuData');
        common.getPkgGroupListCom(this, 'pkgGroup');
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
        getCardStateDict({}).then(res => {
            if (res.data.code == 200) {
                this.cardStateOption = res.data.data;
                let virtualCardStateOption = [];
                for (let i = 0; i < res.data.data.length; i++) {
                    if (res.data.data[i].code < 5 || res.data.data[i].code == 11) {
                        virtualCardStateOption.push(res.data.data[i]);
                    }
                }
                for (let i = 0; i < virtualCardStateOption.length; i++) {
                    this.virtualStateArray.push(virtualCardStateOption[i].code);
                }
            } else {
                this.$message.error(res.data.message);
            }
        })

        this.getAdminCardListHandler();
    }
}
</script>

<style lang="less" scoped></style>

